export const SIRONA_SUBSTITUTION_REGEX: RegExp = /<srna>(.*?)<\/srna>/;

export const isLetter = (char: string): boolean => /^[a-zA-Z]$/.test(char);

export const isTextContainingSubstitutions = (text: string): boolean =>
  new RegExp(SIRONA_SUBSTITUTION_REGEX, 'g').test(text);
